import { ReactElement } from "react";
import { Image, TouchableOpacity, ViewStyle } from "react-native";
import { THEME_COLORS } from "../../../theme/constants/themeColors";
import { THEME_STYLES } from "../../../theme/constants/themeStyles";
import CText from "../../../ui/components/CText";

type Props = {
  onPress: () => void;
  title: string;
  icon?: any;
  iconSvg?: ReactElement;
  style: ViewStyle;
  disabled?: boolean;
};
export default function SmallBorderedButton(props: Props) {
  const {
    onPress = () => {},
    title,
    icon,
    disabled = false,
    iconSvg,
    style = {},
  } = props;

  return (
    <>
      <TouchableOpacity
        activeOpacity={0.7}
        disabled={disabled}
        style={[
          {
            borderRadius: THEME_STYLES.buttonStyle.borderRadius,
            borderWidth: 1,
            backgroundColor: THEME_COLORS.buttonBgColor3,
            borderColor: THEME_COLORS.borderColor,
            flexDirection: "row",
            alignItems: "center",
            padding: 8,
            paddingHorizontal: 12,
            ...THEME_STYLES.cardStyle,
            ...THEME_STYLES.item,
          },
          style,
        ]}
        onPress={onPress}
      >
        {!!iconSvg && <>{iconSvg}</>}
        {!iconSvg && !!icon && (
          <Image
            source={icon}
            style={{ height: 16, width: 16, backgroundColor: THEME_COLORS.buttonBgColor }}
            resizeMode="contain"
          />
        )}
        <CText
          value={title}
          size={10}
          medium
          style={{ marginStart: 8, fontWeight: "600", color: THEME_COLORS.buttonBgColor }}
        />
      </TouchableOpacity>
    </>
  );
}
